import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home-container">
      <Link to="/services" className="services-button-home">
        Services
      </Link>
      <div className="left-column">
        <div className="company-info">
          {/* Logo */}
          <div className="logo">
            <img src="/logo.png" alt="FLYGON LC" className="logo-image" />
          </div>

          {/* Services List */}
          <div className="services-list">
            <div className="service-item">Software + Website Development</div>
            <div className="service-item">Digital Advertising</div>
            <div className="service-item">Media Development + Management</div>
            <div className="service-item">Data Analysis</div>
          </div>

          {/* Business Details */}
          <div className="business-details">
            <div className="detail-item">Over $25M in Ad-Driven Sales</div>
            <div className="detail-item">In-House Support</div>
            <div className="detail-item">On-Site Training</div>
            <div className="detail-item">Based in Phoenix, AZ</div>
            <div className="detail-item">Est. 2020</div>
          </div>

          {/* Referral Only */}
          <div className="referral-only">REFERRAL ONLY</div>

          <div className="copyright-section">
            <div className="copyright-text">COPYRIGHT © 2020-2026 FLYGON LC</div>
            <div className="legal-links">
              <Link to="/privacy" className="legal-link">Privacy Policy</Link>
              <span className="separator"> - </span>
              <Link to="/terms" className="legal-link">Terms and Conditions</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
